/**
 * Design tokens for the StreamLover homepage (see DESIGN.md).
 *
 * When we promote the theme into MUI's ThemeProvider, this is the object that
 * feeds it.
 */

export const colors = {
  chalk: "#F4F2EC",
  ink: "#1E1B2E",
  coral: "#FF5470",
  aqua: "#19C3B2",
  sun: "#FFD23E",
  grape: "#6C4AB6",
} as const;
